import { Title32 } from 'components/Typography'
import { rem } from 'polished'
import styled from 'styled-components'
import { getMainFont } from 'utils/themeUtils'
import { Box } from 'rebass'
import theme from 'styles/theme'

export const Wrapper = styled.div`
  width: 100%;
  padding: ${rem(50)} ${rem(20)};
  flex-shrink: 0;
  margin-top: 50px;
  background-color: ${(props) => props.theme.colors.darkTealToNaturalGreen};

  ${theme.mediaQueries.mobile} {
    height: 100%;
    padding: ${rem(40)} ${rem(20)};
  }
`
export const TitleWrapper = styled.div`
  display: flex;
  margin-top: ${rem(68)};
  justify-content: center;
  color: ${(props) => props.theme.colors.white};
  ${theme.mediaQueries.mobile} {
    margin-top: ${rem(40)};
  }
`
export const CustomTitle = styled(Title32)`
  font-family: ${getMainFont()};
  color: ${(props) => props.theme.colors.secondaryFont};
  font-size: ${rem(30)};
`
export const Icon = styled(Box)`
  max-height: ${rem(32)};
`
export const IconsWrapper = styled.div`
  margin-top: ${rem(33)};
  display: flex;
  width: 100%;
  padding: 0 ${rem(118)};
  gap: ${rem(40)};
  align-items: center;
  justify-content: center;

  ${theme.mediaQueries.mobile} {
    flex-direction: column;
    padding: 0 ${rem(20)};
    gap: ${rem(20)};
    justify-content: right;
    align-items: flex-start;
    justify-content: flex-start;
  }
`
export const IconItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  color: ${(props) => props.theme.colors.secondaryFont};
`

export const DescriptionWrapper = styled.div`
  margin-top: ${rem(45)};
  text-align: center;
  max-width: ${rem(768)};
  margin-left: auto;
  margin-right: auto;
  font-size: ${rem(14)};
  color: ${(props) => props.theme.colors.secondaryFont};

  ${theme.mediaQueries.mobile} {
    font-size: ${rem(10)};
    padding: 0;
    max-width: ${rem(308)};
    margin-left: auto;
    margin-right: auto;
    text-align: left;
  }
`
